export enum SnackBarType {
    SUCCESS = 'success',
    ALERT = 'alert',
}
